import type { PageType } from '@/modules/common/consts'
import { useInfoModal } from '@/utils/hooks/useInfoModal/useInfoModal'
import type { PropsWithChildren, ReactNode } from 'react'
import { H1 } from './heading'
import { cn } from '@/lib/utils'
import { Loader } from '@ur-solutions/react-components'

interface Props extends PropsWithChildren {
  className?: string
  contentClassName?: string

  title: ReactNode
  page?: PageType
  loading?: boolean
}

export function ModuleHeader({
  children,
  className,
  contentClassName,

  title,
  page,
  loading = false,
}: Props) {
  const { infoContent, InfoButton, InfoModal } = useInfoModal(page)

  return (
    <header
      className={cn(
        'flex items-center justify-between mb-2 pl-2 md:mb-6 md:pl-0',
        className
      )}
    >
      <H1 className="flex items-center gap-4">
        {title}
        {!!infoContent && <InfoButton />}
        {loading && <Loader.Spinner size={24} />}
      </H1>

      {!!children && (
        <div className={cn('flex gap-4', contentClassName)}>{children}</div>
      )}

      {!!infoContent && <InfoModal />}
    </header>
  )
}
